import React from 'react';
import {Pressable, StyleSheet, View} from 'react-native';

import theme from '../../style/theme';
import {Icon} from '../Icon';
import Text from '../ui-controls/Text';

import SlideUpModal from './SlideUpModal';

// Both controls carry a testID: `Pressable` is a memo-wrapped component, which
// react-test-renderer cannot match by type, so a test has no other stable
// handle once the sheet holds more than one of them.
export const PROMOTION_SIGN_IN_CLOSE_TEST_ID = 'promotion-user-sign-in-modal-close';
export const PROMOTION_SIGN_IN_NAVIGATE_TEST_ID = 'promotion-user-sign-in-modal-navigate';

function PromotionUserSignInModal({
  isVisible,
  onNavigate,
  onRequestClose,
}: {
  isVisible: boolean;
  onNavigate: () => void;
  onRequestClose?: () => void;
}) {
  // A local handler, not the caller's function passed straight through: the
  // sheet and its close control must dismiss through exactly one path, and
  // `onRequestClose` stays optional for callers that never dismiss.
  const handleRequestClose = () => onRequestClose?.();

  return (
    <SlideUpModal isVisible={isVisible} onRequestClose={handleRequestClose}>
      <View style={styles.container}>
        {/* The close control is absolutely positioned so the `flex: 1` column
            keeps the promotion text and the sign-in button exactly where they
            were. `accessibilityRole` plus an explicit `accessibilityLabel` is
            what makes it announced by a screen reader; `focusable` keeps it in
            the keyboard tab order on web. */}
        <Pressable
          testID={PROMOTION_SIGN_IN_CLOSE_TEST_ID}
          style={styles.close}
          onPress={handleRequestClose}
          accessible={true}
          accessibilityRole="button"
          accessibilityLabel="Close"
          focusable={true}
          hitSlop={12}>
          <Icon name="xmark" size={18} color={theme.colour.text.heading.primary} />
        </Pressable>
        <Text style={{marginTop: 40}}>TO ENTER PROMOTION PLEASE</Text>
        <Pressable
          testID={PROMOTION_SIGN_IN_NAVIGATE_TEST_ID}
          style={styles.button}
          onPress={onNavigate}>
          <Text style={styles.enterText}>{'Sign-in Or Create Account'.toUpperCase()}</Text>
        </Pressable>
      </View>
    </SlideUpModal>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  close: {
    position: 'absolute',
    top: 8,
    right: 12,
    zIndex: 1,
  },
  button: {
    marginTop: 10,
    borderRadius: 4,
    backgroundColor: theme.colour.background.button.primary,
    paddingHorizontal: 12,
    paddingVertical: 8,
  },
  enterText: {
    fontSize: 16,
    color: 'white',
  },
});

export default PromotionUserSignInModal;
